import styled from 'styled-components'
import { COLORS, ANTD_COLORS } from 'theme'
import { Button } from 'antd'

export const FilterSummaryBar = styled.div`
  background: ${COLORS.GREY_T_97};
  border-radius: 4px;
  padding: 8px 12px; /* Reduced from 12px 16px */
  margin-bottom: 8px; /* Reduced from 12px */
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SummaryText = styled.div`
  font-size: 14px;
  color: ${COLORS.BLACK};
  flex-grow: 1;
  
  strong {
    font-weight: 600;
  }
`;

export const ClearFilterButton = styled(Button)`
  margin-left: 12px; /* Reduced from 16px */
  background: #FFEFED !important;
  border: 1px solid #E35E50 !important;
  color:rgb(0, 0, 0) !important;
  
  &:hover, &:focus {
    background: #FFE0DC !important;
    border-color: #E35E50 !important;
    color:rgb(0, 0, 0) !important;
  }
  
  &:active {
    background: #FFCEC7 !important;
    border-color: #E35E50 !important;
    color:rgb(0, 0, 0) !important;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: ${props => (props.column ? 'column' : 'row')};
  width: 100%;
  height: 100%;
  overflow-y: auto;
  gap: 6px; /* Added small gap */
`

export const HeaderContainer = styled.div`
  width: 100%;
  max-width: 1504px;
  margin: 0 auto;
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  margin-bottom: 4px;
`

export const TopSection = styled.div`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 6px 10px;
  border-radius: 6px;
  transition: background-color 0.15s ease;
  &:hover {
    background-color: rgba(50, 73, 215, 0.06);
  }
`

export const TopHeader = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #3249D7;
`

export const ButtonContainer = styled.div`
  display: flex;
  gap: 6px; /* Reduced from 10px */
`

export const AssessmentInfoContainer = styled.div`
  padding-bottom: 6px; /* Reduced from 12px */
  margin-top: 10px; /* Reduced from 15px */
`

export const ContentSection = styled.div`
  padding: 12px 8px;
  width: 100%;
`

export const FormSection = styled.div`
  border-radius: 8px;
  padding: 12px 0 12px 0; /* Reduced from 18px */
  margin-bottom: 10px; /* Reduced from 16px */
`

export const SubHeading = styled.h2`
  font-size: 18px; /* Reduced from 20px */
  font-weight: 600;
  padding-left: 30px; /* Reduced from 37px */
  color: ${COLORS.TEXT_PRIMARY};
  margin: 0; /* Added to remove default margins */
`

export const InstituteName = styled.h3`
  font-size: 18px; /* Reduced from 20px */
  font-weight: 600;
  padding-left: 30px; /* Reduced from 37px */
  color: #3249D7;
  margin: 10px 0 0 0; /* Reduced top from 15px */
`

export const FormRow = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px; /* Reduced from 30px */
  margin-bottom: 8px; /* Reduced from 12px */
  padding-left: 0;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`

export const FormGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px; /* Reduced from 15px */
  margin-left: 0;
`

export const StyledLabel = styled.label`
  font-weight: 700;
  font-size: 14px; /* Reduced from 16px */
  color: ${COLORS.TEXT_PRIMARY};
  white-space: nowrap;
  margin: 0;
  padding: 0;
  letter-spacing: 0.01em;
  text-align: left;
`

export const Select = styled.select`
  width: 160px; /* Reduced from 180px */
  height: 34px; /* Reduced from 38px */
  padding: 0 8px; /* Reduced from 12px */
  font-size: 14px;
  border: 1px solid #D6DBF7;
  border-radius: 8px; /* Reduced from 10px */
  background-color: #FFFFFF;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05); /* Reduced shadow */
  margin-left: 0;

  &:focus {
    border-color: ${COLORS.PRIMARY};
    outline: none;
    box-shadow: 0 0 0 3px rgba(50, 73, 215, 0.1); /* Reduced from 4px */
  }
`

export const StatusContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 4px; /* Reduced from 6px */
  margin-bottom: 10px; /* Reduced from 16px */
  padding-left: 0;
  overflow-x: auto;
  
  @media (max-width: 992px) {
    flex-wrap: wrap;
  }
`

export const StatusItem = styled.div`
  background-color: #F9FAFB;
  padding: 10px; /* Reduced from 14px */
  border-radius: 6px; /* Reduced from 8px */
  border: 1px solid ${props => props.isActive ? '#808697' : '#EAECF0'};
  cursor: pointer;
  transition: border-color 0.2s ease;
  
  &:hover {
    border-color: #3249D7;
  }
  
  .status-label {
    font-size: 13px; /* Reduced from 14px */
    color: #808697;
    margin-bottom: 4px; /* Reduced from 6px */
  }
  
  .status-value {
    font-size: 20px; /* Reduced from 24px */
    font-weight: 600;
    color: ${props => props.isActive ? '#3249D7' : COLORS.TEXT_PRIMARY};
    transition: color 0.2s ease;
  }
`

export const HelperText = styled.p`
  color: ${COLORS.TEXT_SECONDARY};
  font-size: 13px; /* Reduced from 14px */
  margin-top: 12px; /* Reduced from 16px */
`